'use strict';
var frontendUtils = require('honda_cars_ecux/utils/frontendUtils');

const ACCORDION_CONFIG = {
    CLOSE_ON_CHANGE: true, // Whether to close the accordion when a different grade is selected
    OPEN_DELAY_MS: 800 // Delay to allow for price and key feature updates before opening accordion
};

const configuratorGradesAccordion = {
    onGradeChangeSuccess: function (response) {
        const renderKeyFeatures = configuratorGradesAccordion.renderKeyFeatures;
        const openAccordion = configuratorGradesAccordion.openAccordion;
        if (!response?.data?.product?.customProps) { return; };
        const customProperties = response.data.product.customProps;
        const $checkedInput = $('.grade-selector__key-features-list').parents('.radio-cards__card').find('.form-check-input:checked');
        const $gradeSelectorKeyFeaturesList = $checkedInput.siblings('.grade-key-features__contents').find('.grade-selector__key-features-list');
        const keyFeatures = [];

        if (Array.isArray(customProperties.AdditionalKeyFeatures) && customProperties.AdditionalKeyFeatures.length) {
            keyFeatures.push(...customProperties.AdditionalKeyFeatures);
        }

        renderKeyFeatures($gradeSelectorKeyFeaturesList, keyFeatures);
        setTimeout(function () {
            openAccordion($checkedInput);
        }, ACCORDION_CONFIG.OPEN_DELAY_MS);
    },
    renderKeyFeatures: function ($listEl, keyFeatures) {
        if (!$listEl || !$listEl.length) { return; }
        $listEl.html('');
        const frag = document.createDocumentFragment();
        keyFeatures.forEach(function (additionalKeyFeature, index) {
            if (additionalKeyFeature) {
                const li = document.createElement('li');
                li.textContent = additionalKeyFeature;
                frag.appendChild(li);
                if (keyFeatures.length - 1 !== index) {
                    const dot = document.createElement('li');
                    dot.classList.add('grade-selector__key-features-badge');
                    frag.appendChild(dot);
                }
            }
        });
        $listEl.append(frag);
    },
    populateColorVariationPrice: function (selectedColor) {
        const populateMissingVariationPrice = this.populateMissingVariationPrice;
        const renderKeyFeatures = this.renderKeyFeatures;
        const $attributeColor = $('#attribute-color');
        const pid = $attributeColor.data('masterid');
        const params = {};
        const newParams = new URLSearchParams(window.location.search);
        const paramsColor = newParams.get('sv') || '';
        const orderId = newParams.get('orderId') || '';
        const modifyCar = newParams.get('modifyCar') || '';
        const modifyAccessories = newParams.get('modifyAccessories') || '';
        const action = newParams.get('action') || '';

        if (pid) {
            params.pid = pid;
            params[`dwvar_${pid}_color`] = selectedColor || paramsColor;
        }

        if (orderId) {
            params.orderId = orderId;
            params.modifyCar = modifyCar;
            params.modifyAccessories = modifyAccessories;
            params.action = action;
        }

        $.ajax({
            url: $attributeColor.data('action'),
            type: 'get',
            dataType: 'json',
            data: params,
            success: function (data) {
                if (Array.isArray(data.currentColorVariations) && data.currentColorVariations.length) {
                    data.currentColorVariations.forEach(function (colorVariation) {
                        if (colorVariation.grade && colorVariation.BasePrice) {
                            const sanitizedGrade = String(colorVariation.grade);
                            const selector = `[id="variation-grade-price-${sanitizedGrade}"]`;
                            const selectorMobile = `[id="variation-grade-price-m-${sanitizedGrade}"]`;
                            const $keyFeaturesList = $(`#attr-grade-${sanitizedGrade}`).find('.grade-selector__key-features-list');
                            const keyFeatures = [];

                            $(selector).html(`${frontendUtils.formatToAUDollar(colorVariation.BasePrice)}*`);
                            $(selectorMobile).html(`${frontendUtils.formatToAUDollar(colorVariation.BasePrice)}*`);
                            $(selector).parent('.variation-grade-price__slot').addClass('show');
                            $(selectorMobile).parent('.variation-grade-price__slot').addClass('show');


                            if (Array.isArray(colorVariation.AdditionalKeyFeatures) && colorVariation.AdditionalKeyFeatures.length) {
                                keyFeatures.push(...colorVariation.AdditionalKeyFeatures);
                            }

                            renderKeyFeatures($keyFeaturesList, keyFeatures);
                        }
                    });
                }

                if (orderId && sessionStorage.getItem('modifySelectedOrderVariant') !== null && action !== 'Changeconfigurationtonewoffer' && action !== 'changeVIN') {
                    let purchasedVariant = null;
                    try {
                        purchasedVariant = JSON.parse(sessionStorage.getItem('modifySelectedOrderVariant'));
                    } catch (e) {
                        console.error('Failed to parse modifySelectedOrderVariant', e);
                    }

                    if (purchasedVariant) {
                        const currentUrl = new URL(window.location.href);
                        const carModel = currentUrl.pathname.split('/').pop().split('.')[0];
                        if (carModel == purchasedVariant.carModel) {
                            $('.grade-attribute input[data-attr-value]').each(function () {
                                if ($(this).data('attr-value') === purchasedVariant.variant) {
                                    $(this).closest('.radio-cards__card').addClass('modify-order-ordered-value');
                                }
                            });
                        }
                    }
                }

                populateMissingVariationPrice();
            }
        });
    },
    populateMissingVariationPrice: function () {
        $('.variation-grade-price__slot.fade:not(.show)').each(function () {
            const $element = $(this);
            const $attributeColor = $('#attribute-color');
            const params = {};
            const masterId = $attributeColor.data('masterid');
            const grade = $(this).parents('.radio-cards__card').find('input.grade-option-js').data('attrValue');
            params.masterId = masterId;
            params.grade = grade;

            $.ajax({
                url: $attributeColor.data('missing-price'),
                type: 'get',
                dataType: 'json',
                data: params,
                success: function (data) {
                    if (data && data.productBasePrice) {
                        const selector = `[id="variation-grade-price-m-${grade}"]`;
                        $(selector).html(`${frontendUtils.formatToAUDollar(data.productBasePrice)}*`);
                        $($element).addClass('show');
                    }
                }
            });
        });
    },
    openAccordion: function ($trigger) {
        if (!$trigger || !$trigger.length) { return; }

        var target = $trigger.attr('data-target') || $trigger.data('target');
        var $content = $(target);
        var $parent = $trigger.closest('.custom-accordion');
        var $allContents = $parent.find('.custom-accordion-content');

        requestAnimationFrame(function () {
            $allContents.addClass('animating');
            $allContents.removeClass('is-open');
            $parent.find('input[data-accordion-trigger="true"]').attr('aria-expanded', 'false');

            requestAnimationFrame(function () {
                $content.addClass('is-open');
                $trigger.attr('aria-expanded', 'true');

                setTimeout(function () {
                    $allContents.removeClass('animating');
                }, 350);
            });
        });
    },
    closeAccordion: function ($parent) {
        if (!$parent || !$parent.length) { return; }

        var $allContents = $parent.find('.custom-accordion-content');

        requestAnimationFrame(function () {
            $allContents.addClass('animating');
            $allContents.removeClass('is-open');
            $parent.find('input[data-accordion-trigger="true"]').attr('aria-expanded', 'false');

            setTimeout(function () {
                $allContents.removeClass('animating');
            }, 350);
        });
    },
    _currentProductName: null,
    setupPageListeners: function () {
        var self = this;
        var onGradeChangeSuccess = this.onGradeChangeSuccess;
        $('body').on('product:afterAttributeSelect', function (el, response) {
            if (response?.data?.product?.productName) {
                self._currentProductName = response.data.product.productName;
            }
            onGradeChangeSuccess(response);
        });
    },
    setupAccordionBehavior: function () {
        var closeAccordion = this.closeAccordion;
        var $accordionSelector = $('.grade-attribute.custom-accordion');
        var triggerSelector = 'input[data-accordion-trigger="true"]';

        $accordionSelector.each(function () {
            var $accordion = $(this);
            var $triggers = $accordion.find(triggerSelector);

            if (ACCORDION_CONFIG.CLOSE_ON_CHANGE) {
                $triggers.on('change', function () {
                    closeAccordion($accordion);
                });
            }

            if ($triggers.length <= 1) {
                var $firstTrigger = $triggers.first();
                var target = $firstTrigger.attr('data-target') || $firstTrigger.data('target');
                var $content = $(target);
                $content.addClass('is-open');
                $firstTrigger.attr('aria-expanded', 'true');
            }
        });
    },
    setupGATracking: function () {
        var self = this;
        $(document).on('click', '.grade-selector__key-features-cta:not(.grade-selector__offer-details)', function (e) {
            try {
                var $button = $(this);
                var linkText = $button.find('span').text().trim().toLowerCase() || 'see all features';
                var $gradeCard = $button.closest('.radio-cards__card');
                var modelGrade = $gradeCard.find('.grade-option-js').data('attr-value') || null;

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'configurator_key_features_click',

                    action: 'click',
                    content_type: 'configurator',
                    context: 'key_features',
                    'location.onpage': 'grade_selection',

                    // Business / model metadata
                    model_grade: modelGrade,
                    model_id: document.querySelector('#attribute-color')?.dataset?.masterid
                        || document.querySelector('#current-product')?.dataset?.masterid
                        || null,
                    ui_experience: 'configurator',

                    site_session_id: $('.page').data('session-id') || null,
                    timestamp_unix: Math.floor(Date.now() / 1000),

                    link_text: linkText
                });
            } catch (gaError) {
                console.error('GA tracking error:', gaError);
            }
        });
    },
    setupKeyboardNavigation: function () {
        var $accordionContainer = $('.grade-attribute.custom-accordion');
        if (!$accordionContainer.length) return;

        var $accordionCards = $accordionContainer.find('.radio-cards__card[data-radio-id]');
        if (!$accordionCards.length) return;

        function updatePanelFocusability($panel, isOpen) {
            var $focusable = $panel.find('button, a[href], input, select, textarea, [tabindex], [contenteditable="true"]');
            $focusable.each(function () {
                var $el = $(this);
                if (isOpen) {
                    var original = $el.data('original-tabindex');
                    if (original !== undefined) {
                        original ? $el.attr('tabindex', original) : $el.removeAttr('tabindex');
                        $el.removeData('original-tabindex');
                    }
                } else {
                    if ($el.data('original-tabindex') === undefined) {
                        $el.data('original-tabindex', $el.attr('tabindex') || '');
                        $el.attr('tabindex', '-1');
                    }
                }
            });
        }

        function syncAriaState($panel, isOpen) {
            var panelId = $panel.attr('id');
            var $card = $accordionContainer.find('[aria-controls="' + panelId + '"]');
            if ($card.length) {
                $card.attr('aria-expanded', isOpen);
                var $radio = $('#' + $card.data('radio-id'));
                if ($radio.length) {
                    $radio.attr('aria-expanded', isOpen);
                }
                updatePanelFocusability($panel, isOpen);
            }
        }

        $accordionContainer.on('click', '.radio-cards__card[data-radio-id]', function (e) {
            if ($(e.target).closest('button, label, input').length) return;
            var $radio = $('#' + $(this).data('radio-id'));
            if ($radio.length && !$radio.prop('disabled')) {
                $radio.prop('checked', true).trigger('change');
            }
        });

        $accordionContainer.on('keydown', '.radio-cards__card[data-radio-id]', function (e) {
            if (/^(BUTTON|A|INPUT|SELECT|TEXTAREA)$/.test(e.target.tagName)) return;

            var $card = $(this);
            var idx = $accordionCards.index($card);
            var $target = null;
            var handled = false;

            switch (e.key) {
                case 'Enter':
                case ' ':
                    if (e.target === this) {
                        var $radio = $('#' + $card.data('radio-id'));
                        if ($radio.length && !$radio.prop('disabled')) {
                            $radio.prop('checked', true).trigger('change');
                        }
                        handled = true;
                    }
                    break;
                case 'ArrowDown':
                case 'Down':
                    $target = $accordionCards.eq((idx + 1) % $accordionCards.length);
                    handled = true;
                    break;
                case 'ArrowUp':
                case 'Up':
                    $target = $accordionCards.eq((idx - 1 + $accordionCards.length) % $accordionCards.length);
                    handled = true;
                    break;
                case 'Home':
                    $target = $accordionCards.first();
                    handled = true;
                    break;
                case 'End':
                    $target = $accordionCards.last();
                    handled = true;
                    break;
            }

            if ($target && $target.length) {
                $target.focus();
            }

            if (handled) {
                e.preventDefault();
                e.stopPropagation();
            }
        });

        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    var $panel = $(mutation.target);
                    if ($panel.hasClass('grade-key-features__contents')) {
                        syncAriaState($panel, $panel.hasClass('is-open'));
                    }
                }
            });
        });

        $accordionCards.each(function () {
            var $card = $(this);
            var $panel = $('#' + $card.attr('aria-controls'));
            if ($panel.length) {
                var isOpen = $panel.hasClass('is-open');
                $card.attr('aria-expanded', isOpen);
                updatePanelFocusability($panel, isOpen);
                var $radio = $('#' + $card.data('radio-id'));
                if ($radio.length) {
                    $radio.attr('aria-expanded', isOpen);
                }
                observer.observe($panel[0], { attributes: true, attributeFilter: ['class'] });
            }
        });
    },
    init: function () {
        this.setupPageListeners();
        this.setupAccordionBehavior();
        this.setupGATracking();
        this.setupKeyboardNavigation();
    }
}

module.exports = configuratorGradesAccordion;
